import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Button, Input, Row, Space } from "antd";

import apiService from "../../utils/ApiService";

import ProductLinkInformationModal from "./ProductLinkInformationModal";
import ProductLinkModal from "./ProductLinkModal";

const api = new apiService();
const ProductComponent = ({
	item,
	handleChangePagination,
	currentPageNumber,
	selectedLinkItem,
	setSelectedLinkItem,
}) => {
	const user = useSelector((state) => state.auth.user);

	const [queryLoading, setQueryLoading] = useState(false);
	const [queryUrl, setQueryUrl] = useState(item.product_link ?? "");

	const [linkShow, setLinkShow] = useState(false);
	const [linkInfoShow, setLinkInfoShow] = useState(false);

	useEffect(() => {
		setLinkShow(false);
	}, [currentPageNumber]);

	const handleCopyLink = (e) => {
		window.navigator.clipboard.writeText(e.currentTarget.value).then(() => {
			alert("링크 복사가 완료 되었습니다.");
			setLinkShow(false);
		});
	};

	const featureList = {
		title: item?.usp,
		contentList: [
			...Array.from({ length: 6 }).map((arr, idx) => {
				return item[`information_${idx + 1}`];
			}),
		].filter((arr) => arr !== null),
	};

	const handleCopyFeatures = () => {
		let text = "";
		featureList.contentList?.map((feature, idx) => {
			if (feature) {
				console.log(feature);
				text += `0${idx + 1}. ${feature} \n`;
			}
		});
		const textValue = `${featureList.title}\n\n${text}`;
		window.navigator.clipboard.writeText(textValue).then(() => {
			alert("복사가 완료 되었습니다.");
			setLinkShow(false);
		});
	};

	const [returnQuery, setReturnQuery] = useState({});

	const onClickShowLink = () => {
		setSelectedLinkItem(item);
		let link = item?.product_link;
		if (link) {
			setQueryUrl(link);
			setLinkShow(true);
		} else {
			checkNotDuplication();
		}
	};

	/**
	 * 쿼리 중복 여부 체크
	 * @returns {Promise<{result, query: string}>}
	 * true : 중복 아님, false: 중복
	 */
	const checkNotDuplication = async () => {
		setQueryLoading(true);
		let text = "";
		const possible =
			"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
		let isValid = false;
		while (!isValid) {
			for (let i = 0; i < 8; i++) {
				text += possible.charAt(Math.floor(Math.random() * possible.length));
			}
			let param = {
				user_id: user.id,
				product_id: item.product_id,
				query: text,
			};
			const res = await api.checkDuplicateProductLink(param);
			if (res.data.code === 200) {
				if (!isValid) {
					setReturnQuery({
						result: res.data.result,
						query: text,
					});
				}
				isValid = true;
			}
		}
	};

	useEffect(() => {
		if (
			Object.prototype.hasOwnProperty.call(returnQuery, "result") &&
			Object.prototype.hasOwnProperty.call(returnQuery, "query")
		) {
			createRandomQuery();
		}
	}, [returnQuery]);

	/**
	 * 쿼리 생성
	 * @returns {Promise<void>}
	 */
	const createRandomQuery = async () => {
		// true: 중복아님, false: 중복
		if (!queryLoading) {
			setQueryLoading(true);
		}
		const { result, query } = returnQuery;
		const dataQuery = !!item?.product_link;
		if (!dataQuery && result) {
			let param = {
				product_id: item?.product_id,
				user_id: user.id,
				query: query,
			};
			const res = await api.issueProductLink(param);
			if (res.data.code === 200) {
				setQueryUrl(res.data.result.query);
				setLinkShow(true);
				handleChangePagination(currentPageNumber, "query");
			}
		}
		setQueryLoading(false);
	};

	return (
		<>
			<div className={`commission-product-image-div`}>
				<img
					src={`${process.env.REACT_APP_S3_HOST}/image/recommend/${item.target_id}.jpg`}
					onError={({ currentTarget }) => {
						currentTarget.onerror = null; // prevents looping
						// currentTarget.style.display = "none";
						currentTarget.src = `/assets/images/no-product.png`;
					}}
					alt={`${item.brand_name} ${item.name}`}
					style={{
						// width: "100%",
						// height: "11em",
						objectFit: "cover",
					}}
				/>
			</div>
			<div
				className={`commission-wrap`}
				style={{
					// backgroundColor: "#ff0027",
					backgroundColor: "#fe2b4b",
				}}
			>
				커미션 <span>{item?.commission_rate ?? 0}%</span>
			</div>

			<Space
				// direction={`vertical`}
				style={{ width: "100%", padding: "0.5em 0" }}
				className={`product-info-wrap`}
			>
				<Button
					shape="round"
					style={{
						width: "100%",
					}}
					onClick={() => {
						setLinkInfoShow(true);
						// window.open(`https://www.dangyoung.com/products/${item.target_id}`);
					}}
				>
					<img src={`/assets/images/products/info.png`} alt={`상품 정보`} />
					<span>상품정보</span>
				</Button>
				<Button
					shape="round"
					style={{
						width: "100%",
					}}
					onClick={onClickShowLink}
					loading={queryLoading}
				>
					<img src={`/assets/images/products/link.png`} alt={`링크 생성`} />
					<span>링크생성</span>
				</Button>

				{/*{linkShow && item.id === selectedLinkItem?.id && (*/}
				{/*	<Row className={`link-create-wrap`}>*/}
				{/*		<div className={`link-create-div`}>*/}
				{/*			<Input*/}
				{/*				type={`text`}*/}
				{/*				value={`https://www.dangyoung.com/products/${item.target_id}?query=${queryUrl}`}*/}
				{/*			/>*/}
				{/*			<Button*/}
				{/*				value={`https://www.dangyoung.com/products/${item.target_id}?query=${queryUrl}`}*/}
				{/*				onClick={handleCopyLink}*/}
				{/*			>*/}
				{/*				링크복사*/}
				{/*			</Button>*/}
				{/*		</div>*/}
				{/*		{featureList?.contentList?.length > 0 && (*/}
				{/*			<div className={`link-create-features`}>*/}
				{/*				<p className={`title`}>{featureList.title}</p>*/}
				{/*				<div className={`feature-list`}>*/}
				{/*					{featureList.contentList?.map((item, idx) => (*/}
				{/*						<p className={`content`} key={`featureList-${idx}`}>*/}
				{/*							<span>0{idx + 1}</span>*/}
				{/*							{item}*/}
				{/*						</p>*/}
				{/*					))}*/}
				{/*				</div>*/}
				{/*				<div className={`link-feature-copy`}>*/}
				{/*					<p>장점 텍스트를 복사해서 사용해보세요!</p>*/}
				{/*					<Button onClick={handleCopyFeatures}>전체복사</Button>*/}
				{/*				</div>*/}
				{/*			</div>*/}
				{/*		)}*/}
				{/*	</Row>*/}
				{/*)}*/}
			</Space>

			{/* 상품 정보 모달 */}
			<ProductLinkInformationModal
				item={item}
				linkInfoShow={linkInfoShow}
				setLinkInfoShow={setLinkInfoShow}
			/>

			{/* 상품 링크 모달 */}
			<ProductLinkModal
				user={user}
				linkShow={linkShow}
				setLinkShow={setLinkShow}
				selectedLinkItem={selectedLinkItem}
				queryUrl={queryUrl}
			/>

			<div className={`product-name-wrap`}>
				<span className={`product-brand-name`}>
					{item.product_brand_name ? item.product_brand_name : item.brand_name}
				</span>
				<span className={`product-name`}>
					{item.product_name ? item.product_name : item.name}
				</span>
				<span className={`price`}>
					{item.price_2
						? item.price_2?.toLocaleString()
						: item.price_1?.toLocaleString()}
					원
				</span>
				<Row style={{ gap: "2px" }} align={"middle"}>
					<img
						src={`/assets/images/products/review.png`}
						alt={`화살표`}
						style={{
							height: "0.8em",
							width: "auto",
						}}
					/>
					{!item?.review_score ? (
						<span className={`review`}>
							{item?.total_review_score
								? item?.total_review_score.toFixed(1)
								: 0}{" "}
							({item?.total_review_cnt > 999 ? "999+" : item?.total_review_cnt})
						</span>
					) : (
						<span className={`review`}>
							{item?.review_score ? item?.review_score.toFixed(1) : 0} (
							{item?.review_count > 999 ? "999+" : item?.review_count})
						</span>
					)}
				</Row>
			</div>

			{/*<Space className={`tag-list`}>*/}
			{/*	{item.is_best && <Button className={`tag-black`}>BEST</Button>}*/}
			{/*	{item.is_new && <Button className={`tag`}>NEW</Button>}*/}
			{/*	{item.exposure_tag_1 && (*/}
			{/*		<Button className={`tag`}>{item.exposure_tag_1}</Button>*/}
			{/*	)}*/}
			{/*	{item.exposure_tag_2 && (*/}
			{/*		<Button className={`tag`}>{item.exposure_tag_2}</Button>*/}
			{/*	)}*/}
			{/*	{item.exposure_tag_3 && (*/}
			{/*		<Button className={`tag`}>{item.exposure_tag_3}</Button>*/}
			{/*	)}*/}
			{/*</Space>*/}
		</>
	);
};

export default ProductComponent;
